import { Outlet } from 'react-router-dom';
import Sidebar from './Sidebar';
import WhatsAppFloat from './WhatsAppFloat';
import PhoneVerificationModal from './PhoneVerificationModal';
import './Layout.css';

export default function Layout() {
  return (
    <div className="layout">
      <Sidebar />
      <main className="main-content">
        <Outlet />
      </main>
      <WhatsAppFloat />
      <PhoneVerificationModal />
    </div>
  );
}
